import { VeltRecorderControlPanel, VeltRecorderNotes, VeltRecorderTool } from '@veltdev/react';
import React from 'react'
import './ScreenRecorderPage.css';

function ScreenRecorderPage() {
    return (
        <div id="recorderContainer">
            <VeltRecorderNotes />
            <VeltRecorderControlPanel />
            <div className="recorder-main-view">
                <p className="boujeeText">Example of stored recordings</p>
                <section className="saved-recorders-panel">
                    {/* <div id="audioRecording" className='saved-recorder-example'></div>
                    <div id="videoRecording" className='saved-recorder-example'></div> */}
                    <div id="screenRecording" className='saved-recorder-example'></div>
                </section>
                <p className="boujeeText">Click on the button below to start recording.</p>
                <div className='recorder-tools-container'>
                    {/* <VeltRecorderTool type='audio' />
                    <VeltRecorderTool /> */}
                    <VeltRecorderTool type='screen' />
                    <VeltRecorderTool type='all' />
                </div>
            </div>
        </div>
    )
}

export default ScreenRecorderPage;